import axios from 'axios';

// Production API URL
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.bringit.co.in/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const adminAPI = {
  // Users
  getAllUsers: () => api.get('/users'),
  deleteUser: (id: string) => api.delete(`/users/${id}`),
  
  // Partners
  getAllPartners: () => api.get('/partners'),
  verifyPartner: (id: string) => api.patch(`/partners/${id}/verify`),
  approvePartner: (id: string) => api.patch(`/partners/${id}/approve`),
  rejectPartner: (id: string) => api.patch(`/partners/${id}/reject`),
  deletePartner: (id: string) => api.delete(`/partners/${id}`),
  
  // Orders
  getAllOrders: () => api.get('/orders/all'),
  updateOrderStatus: (id: string, status: string) => 
    api.patch(`/orders/${id}/status`, { status }),
  deleteOrder: (id: string) => api.delete(`/orders/${id}/admin`),
  
  // Items
  getAllItems: () => api.get('/items'),
  createItem: (data: any) => api.post('/items', data),
  updateItem: (id: string, data: any) => api.put(`/items/${id}`, data),
  deleteItem: (id: string) => api.delete(`/items/${id}`),
  
  // Stores
  getAllStores: () => api.get('/stores'),
  createStore: (data: any) => api.post('/stores', data),
  updateStore: (id: string, data: any) => api.put(`/stores/${id}`, data),
  deleteStore: (id: string) => api.delete(`/stores/${id}`),
  
  // Stats
  getDashboardStats: () => api.get('/admin/stats'),

  // Payment Requests
  getAllPaymentRequests: () => api.get('/partners/admin/payment-requests'),
  approvePaymentRequest: (partnerId: string, requestId: string) => 
    api.patch(`/partners/${partnerId}/payment-request/${requestId}/approve`),
  rejectPaymentRequest: (partnerId: string, requestId: string, reason?: string) => 
    api.patch(`/partners/${partnerId}/payment-request/${requestId}/reject`, { reason }),
  markPaymentPaid: (partnerId: string, requestId: string) => 
    api.patch(`/partners/${partnerId}/payment-request/${requestId}/paid`),

  // Categories
  getCategories: () => api.get('/categories'),
  addCategory: (data: any) => api.post('/categories', data),
  updateCategory: (id: string, data: any) => api.put(`/categories/${id}`, data),
  deleteCategory: (id: string) => api.delete(`/categories/${id}`),

  // Banners
  getAllBanners: () => api.get('/banners/all'),
  getBanners: () => api.get('/banners'),
  createBanner: (data: any) => api.post('/banners', data),
  updateBanner: (id: string, data: any) => api.put(`/banners/${id}`, data),
  deleteBanner: (id: string) => api.delete(`/banners/${id}`),
};

export default api;
